import {useHistory} from "react-router"
import {Button} from "@mui/material"
import {ReportSubPaths} from "../../../../ReportSubPaths"
import React from "react"
import {TestTakerSearchApi} from "../TestTakerSearchApi"
import {messageStore} from "../../../../../common/messages/MessageStore"

export const TakeSearchBaseURL = (groupId: number) => `${ReportSubPaths.REPORTS_BASE}/group/${groupId}`

export async function navigateToTestTakerSearch(history: ReturnType<typeof useHistory>, groupId?: number) {
    // SSO pages do not use a root group id
    // If we are linking from an SSO page, we will need to find the root group id ourselves
    try {
        const rootGroupId = groupId ?? await TestTakerSearchApi.getSsoRootGroup()
        history.push(TakeSearchBaseURL(rootGroupId))
    } catch {
        messageStore.setErrorMessage("There was an error identifying a root group for this sso user.")
    }
}

export type TestTakerSearchLinkProps = {
    groupId?: number
}
export const TestTakerSearchLink = ({groupId}: TestTakerSearchLinkProps) => {
    const history = useHistory()
    return (
        <Button sx={{maxWidth: "fit-content"}}
                onClick={() => navigateToTestTakerSearch(history, groupId)}>Test Taker Search
        </Button>
    )
}